<template>
  <div class="card">
    <p class="card-header text-2xl">Cho chúng mình thêm một chút thông tin</p>
    <form @submit.prevent="submitRsvp" class="rsvp-form">
      <div class="form-group align-items-center">
        <label>Bạn sẽ tham dự ?</label>
        <div class="horizontal-form-group">

          <label class="text-2xl" for="ceremony" :class="{ 'selected': toCeremony }">
            ⛪
            <!-- <i v-if="!toCeremony" class="pi pi-question text-gray-500"></i> -->
            <i v-if="toCeremony" class="pi pi-check"></i>
            <input type="checkbox" name="ceremony" v-model="toCeremony" id="ceremony">
          </label>

          <label class="text-2xl" for="party" :class="{ 'selected': toParty }">
            🥂🍽️
            <!-- <i v-if="!toParty" class="pi pi-question text-gray-500"></i> -->
            <i v-if="toParty" class="pi pi-check"></i>
            <input type="checkbox" name="party" v-model="toParty" id="party">
          </label>
        </div>
      </div>
      <div v-if="isAttending" class="form-group">
        <label for="guestsCount">Số lượng khách (bao gồm bạn):</label>

        <div class="flex gap-4 w-full flex-1 guest-count">
          <!-- Người lớn -->
          <div class="">

            <div class="flex flex-column align-items-center gap-1 relative">
              <!-- Plus Button -->
              <Button icon="pi pi-chevron-up" class="mb-2" severity="info" rounded aria-label="plus adult"
                @click="increment('adult')" />
              <!-- <button class="p-button p-button-sm" @click="increment('adult')" type="button"><i
                  class="pi pi-plus"></i></button> -->

              <!-- Number Input -->
              <label for="adultGuestsCount" class="number-label absolute">Người lớn:</label>
              <input class="text-center" type="number" id="adultGuestsCount" v-model.number="adultGuestsCount" min="1"
                max="5" required />

              <!-- Minus Button -->
              <Button icon="pi pi-chevron-down" class="mb-2" severity="info" rounded aria-label="minus adult"
                @click="decrement('adult')" />
            </div>
          </div>

          <!-- Trẻ em -->
          <div class="">
            <div class="flex flex-column align-items-center gap-1 relative">
              <!-- Plus Button -->
              <Button icon="pi pi-chevron-up" class="mb-2" severity="info" rounded aria-label="plus child"
                @click="increment('child')" />

              <!-- Number Input -->
              <label for="childGuestsCount" class="number-label absolute">Trẻ em:</label>
              <input class="text-center" type="number" id="childGuestsCount" v-model.number="childGuestsCount" min="0"
                max="5" />

              <!-- Minus Button -->
              <Button icon="pi pi-chevron-down" class="mb-2" severity="info" rounded aria-label="minus child"
                @click="decrement('child')" />
            </div>
          </div>
        </div>
      </div>

      <div class="form-group align-items-center flex-row gap-3 car">
        <label class="flex-initial">Bạn có đi xe không ?</label>
        <div class="horizontal-form-group">

          <label class="text-2xl flex align-items-center" for="car" :class="{ 'selected': withCar }">
            <i class="text-2xl pi pi-car mr-2"></i>
            <!-- <i v-if="!withCar" class="pi pi-question text-gray-500"></i> -->
            <i v-if="withCar" class="pi pi-check"></i>
            <input type="checkbox" name="car" v-model="withCar" id="car">
          </label>
        </div>
      </div>

      <div class="form-group">
        <label for="entertainment" class="flex align-items-center">Văn nghệ:</label>
        <textarea id="note" v-model="entertainment" rows="2"
          placeholder="Ý tưởng trò chơi hay tiết mục văn nghệ"></textarea>
      </div>

      <div class="form-group">
        <label for="note" class="flex align-items-center">Ghi chú:</label>
        <textarea id="note" v-model="note" rows="2"
          placeholder="Vui lòng ghi rõ nếu bạn có dị ứng thực phẩm"></textarea>
      </div>

      <p v-if="submitMessage" :class="['submit-message', submitMessageType]">{{ submitMessage }}</p>
      <button type="submit" class="submit-button">Gửi phản hồi</button>
    </form>
  </div>
</template>

<script>
import { guestNameService } from '@/services/guest-name.service';
import { ref, push, onValue, update } from 'firebase/database';
import Button from 'primevue/button';

export default {
  name: 'RsvpFormComponent',
  props: {
    ceremonyName: {
      type: String,
      default: "Mairie Noisy le Grand",
    },
    ceremonyAddress: {
      type: String,
      default: "https://maps.app.goo.gl/KrhQjYVj7AU4xFvw5",
    },
    invitationDate: {
      type: String,
      default: "14/06/2025",
    },
    ceremonyStartTime: {
      type: String,
      default: "10:30",
    },
    partyStartTime: {
      type: String,
      default: "12:00",
    },
  },
  components: {
    Button,
  },
  data() {
    return {
      rsvpKey: null,
      guestName: guestNameService.guestName || "",
      toCeremony: false,
      toParty: false,
      withCar: false,
      submitMessage: "",
      submitMessageType: "", // 'success' or 'error'
      adultGuestsCount: 1,
      childGuestsCount: 0,
      entertainment: "",
      note: "",
      appsScriptUrl:
        "https://script.google.com/macros/s/AKfycbye2vGXfTtYKEGceystv6PrAga2X_tZ5bBYkEYtifOg1eQb3K2Zs9K1QYim7Qy9cFS2/exec",
    };
  },
  computed: {
    isAttending() {
      return this.toCeremony || this.toParty;
    },
  },
  mounted() {
    if (this.guestName) {
      this.loadExistingRsvp();
    }
  },
  methods: {
    async submitRsvp() {
      if (!this.guestName) {
        this.submitMessage = "Bạn vui lòng điền tên mình nhé.";
        this.submitMessageType = "error";
        return;
      }
      if (
        this.isAttending &&
        (this.adultGuestsCount < 1 ||
          isNaN(this.adultGuestsCount) ||
          isNaN(this.childGuestsCount))
      ) {
        this.submitMessage = "Số lượng khách không hợp lệ.";
        this.submitMessageType = "error";
        return;
      }
      if (this.guestName.trim().length < 2 || this.guestName.length > 50) {
        this.submitMessage = "Tên phải từ 2 đến 50 ký tự.";
        this.submitMessageType = "error";
        return;
      }
      if (this.adultGuestsCount + this.childGuestsCount > 6) {
        this.submitMessage = "Số lượng khách tối đa là 6.";
        this.submitMessageType = "error";
        return;
      }

      this.submitMessage = "Đang gửi...";
      this.submitMessageType = "";

      const rsvpData = {
        timestamp: new Date().toISOString(),
        name: this.guestName,
        toCeremony: this.toCeremony ? "Có" : "Không",
        toParty: this.toParty ? "Có" : "Không",
        adultGuestsCount: this.isAttending ? this.adultGuestsCount : 0,
        childGuestsCount: this.isAttending ? this.childGuestsCount : 0,
        withCar: this.withCar ? "Có" : "Không",
        note: this.note || "",
        entertainment: this.entertainment || "",
      };

      try {
        const rsvpsRef = ref(this.$db, "rsvps");

        if (this.rsvpKey) {
          // 🔁 Update existing
          const entryRef = ref(this.$db, `rsvps/${this.rsvpKey}`);
          await update(entryRef, rsvpData);
        } else {
          // ➕ Create new
          await push(rsvpsRef, rsvpData);
        }

        this.submitMessage =
          this.isAttending
            ? "Cảm ơn bạn! Thứ 7 gặp nhé !"
            : "Tiếc quá, thôi hôm nào cafe !";
        this.submitMessageType = "success";

        this.adultGuestsCount = undefined;
        this.childGuestsCount = undefined;
        this.toCeremony = false;
        this.toParty = false;
        this.note = "";
        this.withCar = false;
        this.entertainment = "";
      } catch (error) {
        this.submitMessage = `Đã xảy ra lỗi khi gửi phản hồi: ${error.message}`;
        this.submitMessageType = "error";
        console.error("Firebase RSVP submission error:", error);
      }
    },
    async loadExistingRsvp() {
      const rsvpsRef = ref(this.$db, 'rsvps');

      onValue(rsvpsRef, (snapshot) => {
        const data = snapshot.val();
        if (!data) return;

        for (const [key, value] of Object.entries(data)) {
          if (value.name?.toLowerCase().trim() === this.guestName.toLowerCase().trim()) {
            this.rsvpKey = key; // 🔑 store key for update

            // Populate fields
            this.toCeremony = value.toCeremony === 'Có';
            this.toParty = value.toParty === 'Có';
            this.withCar = value.withCar === 'Có';
            this.adultGuestsCount = Number(value.adultGuestsCount || 1);
            this.childGuestsCount = Number(value.childGuestsCount || 0);
            this.note = value.note || '';
            this.entertainment = value.entertainment || '';
            break;
          }
        }
      }, {
        onlyOnce: true,
      });
    },
    increment(type) {
      console.log("Incrementing", type);
      if (type === 'adult' && this.adultGuestsCount < 5) {
        this.adultGuestsCount++
      }
      if (type === 'child' && this.childGuestsCount < 5) {
        this.childGuestsCount++
      }
    },
    decrement(type) {
      if (type === 'adult' && this.adultGuestsCount > 1) {
        this.adultGuestsCount--
      }
      if (type === 'child' && this.childGuestsCount > 0) {
        this.childGuestsCount--
      }
    }
  },
}
</script>

<style scoped>
.invitation-footer p {
  font-size: 1rem;
  line-height: 1.5;
  color: #666;
  margin-bottom: 15px;
  /* Added spacing for form */
}

/* NEW FORM STYLES */
.rsvp-form {
  width: 100%;
  /* Limit form width */
  display: flex;
  gap: 20px;
  flex-direction: column;
}

.form-group {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}

.form-group label {
  color: #555;
  margin-bottom: 5px;
  font-weight: 500;
  font-family: "BeautiqueDisplay", cursive;
}

.form-group>label {
  font-size: 1.1rem;
  width: 144px;
  text-align: left;
}

.form-group input[type="checkbox"] {
  display: none;
  width: 0;
  height: 0;
}

label:has(input[type="checkbox"]) {
  border: 1px solid lightgray;
  border-radius: 1rem;
  font-size: 1rem;
  cursor: pointer;
  padding: 8px 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: border-color 0.3s ease, background-color 0.3s ease;
  margin-bottom: 8px;

  &:hover {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
  }

  &.selected {
    background-color: #facfcf;
    border-width: 1.5px;
    color: #f97575;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
  }
}

.form-group input,
.form-group textarea {
  flex: 1;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  color: #333;
  text-align: left;

  transition: all 0.3s ease;

  &::placeholder {
    color: #aaa;
    font-style: italic;
  }
}

.form-group input[type="number"] {
  width: 4.8rem;
  -moz-appearance: textfield;
  -webkit-appearance: none;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

.number-label {
  font-family: "BeautiqueDisplay", cursive;
  font-size: 0.75rem;
  font-weight: 500;
  top: 2.5rem;
  padding: 4px;
  background-color: white;
}

.horizontal-form-group {
  display: flex;
  gap: 8px;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  border-color: #b23a48;
  box-shadow: 0 0 0 3px rgba(178, 58, 72, 0.2);
  outline: none;
}

.submit-button {
  background-color: #b23a48;
  color: #fff;
  padding: 12px 25px;
  margin-top: 20px;
  border: none;
  border-radius: 8px;
  font-size: 1.05rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  align-self: flex-end;
  /* Align button to the right */
}

.submit-button:hover {
  background-color: #e07a5f;
  /* Lighter red on hover */
  transform: translateY(-1px);
}

.submit-button:active {
  transform: translateY(0);
}

.submit-message {
  margin-top: 15px;
  font-size: 0.95rem;
  text-align: right;
  /* Keep message aligned right */
  width: 100%;

  p {
    margin: 0;
  }
}

.pi-check {
  color: #b23a48;
}

.submit-message.success {
  color: green;
}

.submit-message.error {
  color: red;
}

@media screen and (max-width: 768px) {
  .form-group {
    flex-direction: column;
    gap: 4px;

    &.car {
      justify-content: center;
    }
  }

  .form-group>label {
    width: unset;
    flex: 1;
    text-align: left;
  }

  .form-group input,
  .form-group textarea {
    width: 100%;
    max-width: 100%;
  }

  .form-group textarea {
    min-height: 80px;
  }

  .guest-count {
    justify-content: center;
  }
}
</style>